module.exports = __webpack_public_path__ + "67838c38.png";